import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBomb,
  faChevronDown,
  faChevronUp,
  faArrowRight,
  faArrowLeft,
  faHeart,
  faAngleDown,
  faSearch,
  faBars,
  faAngleRight,
  faEnvelope,
  faRectangleLandscape,
  faCalendarCheck,
  faCalendarPlus,
  faChevronLeft,
  faChevronRight,
  faArrowDown,
  faPhone,
  faDownload,
  faExclamationCircle,
  faCheckCircle,
  faSpinner
} from "@fortawesome/pro-solid-svg-icons";
import {
  faCircle,
  faListUl
} from "@fortawesome/pro-regular-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faYoutube,
  faLinkedinIn,
  faGooglePlusG,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

library.add( faAngleDown );
library.add( faAngleRight );
library.add( faArrowDown );
library.add( faArrowLeft );
library.add( faArrowRight );
library.add( faBars );
library.add( faBomb );
library.add( faCalendarCheck );
library.add( faCalendarPlus );
library.add( faChevronDown );
library.add( faChevronLeft );
library.add( faChevronRight );
library.add( faChevronUp );
library.add( faDownload );
library.add( faEnvelope );
library.add( faEnvelope );
library.add( faHeart );
library.add( faPhone );
library.add( faRectangleLandscape );
library.add( faSearch );
library.add( faCircle );
library.add( faListUl );
library.add( faFacebookF );
library.add( faTwitter );
library.add( faYoutube );
library.add( faLinkedinIn );
library.add( faGooglePlusG );
library.add( faInstagram );
library.add( faExclamationCircle );
library.add( faCheckCircle );
library.add( faSpinner );
